import { render, staticRenderFns } from "./SpaceVerticalProperty.vue?vue&type=template&id=1c797871&"
import script from "./SpaceVerticalProperty.vue?vue&type=script&lang=js&"
export * from "./SpaceVerticalProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports